import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Customer} from "../customers/types.ts";

export type SubscriptionDimension = { name: string, value: string }

export enum CustomerSubscriptionStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}

export type CustomerSubscription = {
    id: string,
    customerId: string,
    customer?: Customer,
    items: SubscriptionItemConnection,
    status: CustomerSubscriptionStatus
    createdByUsername?: string,
    createdByUser?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
    updatedByUsername?: string,
}

export type SubscriptionItemConnection = {
    items: SubscriptionItem[],
    nextToken?: string
}

export type SubscriptionItem = {
    id: string,
    subscriptionId: string,
    priceId: string,
    price?: { product?: { name?: string }, [key: string]: unknown },
    quantity: number
}


export interface ICustomerSubscriptionTableColumn extends ITableColumn {
    render?: (item: CustomerSubscription) => ReactNode;
}
